<template lang="pug">
v-tab-item
    feathers-vuex-find(service="bh-items" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title Item Database
                v-spacer
                v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search Name" single-line hide-details)
                //- dialog-add-code(@success="$emit('success')" @error="$emit('error', $event)")
                new-item(@success="$emit('success')" @error="$emit('error', $event)")
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )
                template(v-slot:item.icon_image="{ item }")
                    img(v-if="!!item.icon_image" :src="item.icon_image" width="32" height="32")

                template(v-slot:item.image="{ item }")
                    img(:src="item.image" :height="64")

                template(v-slot:item.name="{ item }") {{ item.name }}
                    br
                    i(style="font-size: 12px; color: #9d9d9d;") ({{ item.description }})

                template(v-slot:item.createdAt="{ item }") {{ item.createdAt | dateFormat }}

                template(v-slot:item.actions="{ item }")
                    new-item(:item="item" @success="$emit('success')" @error="$emit('error', $event)")
</template>

<script>
import moment from 'moment';
import NewItem from './NewItem.vue';

export default {
    data() {
        return {
            searchUser: '',
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Icon',
                    align: 'start',
                    sortable: false,
                    value: 'icon_image'
                },
                {
                    text: 'Image',
                    align: 'start',
                    sortable: false,
                    value: 'image'
                },
                {
                    text: 'Name / Description',
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Type',
                    align: 'end',
                    sortable: false,
                    value: 'type'
                },
                {
                   text: 'Date Created',
                    align: 'end',
                    sortable: true,
                    value: 'createdAt'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    sortable: false,
                    value: 'actions'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['createdAt'],
                sortDesc: [true]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { name: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { name: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
    },
    components: {
        NewItem
    }
}
</script>